/** Fixed model list for beta (OpenAI-only) — shared by execute chat and Assistant landing. */
export const CHAT_AVAILABLE_MODELS = [
  { id: 'gpt-6-sol-high', name: 'GPT - High', provider: 'OpenAI', providerId: 'openai', intelligenceLevel: 'high', type: 'chat' },
  { id: 'gpt-6-sol', name: 'GPT - Medium', provider: 'OpenAI', providerId: 'openai', intelligenceLevel: 'medium', type: 'chat' },
  { id: 'gpt-6-luna', name: 'GPT - Low', provider: 'OpenAI', providerId: 'openai', intelligenceLevel: 'low', type: 'chat' },
];
